import RecurrenceModificationPenaltyContainer from './RecurrenceModificationPenaltyContainer'

export default RecurrenceModificationPenaltyContainer



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/shared/components/RecurrenceModificationPenalty/index.js